var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _circle2, _path, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgNoNotes = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 108 108"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 54,
  r: 54,
  fill: "#E0E0E0"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 31,
  y: 24,
  width: 46,
  height: 61,
  rx: 4,
  fill: "#fff"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 31,
  width: 28,
  height: 4,
  rx: 2,
  fill: "#E0E0E0"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 49,
  width: 40,
  height: 4,
  rx: 2,
  fill: "#E0E0E0"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 40,
  width: 40,
  height: 4,
  rx: 2,
  fill: "#E0E0E0"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 58,
  width: 40,
  height: 4,
  rx: 2,
  fill: "#E0E0E0"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 67,
  width: 40,
  height: 4,
  rx: 2,
  fill: "#E0E0E0"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 73.5,
  cy: 83.5,
  r: 7.5,
  fill: "#B55A72"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M77.084 79.922a.566.566 0 0 0-.802 0L73.5 82.698l-2.782-2.782a.566.566 0 1 0-.802.802l2.782 2.782-2.782 2.782a.566.566 0 1 0 .802.802l2.782-2.782 2.782 2.782a.566.566 0 1 0 .802-.802L74.302 83.5l2.782-2.782a.57.57 0 0 0 0-.796Z",
  fill: "#fff"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 76,
  width: 26,
  height: 4,
  rx: 2,
  fill: "#E0E0E0"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  x: 27,
  y: 22,
  width: 54,
  height: 69,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export default SvgNoNotes;